module.exports = __webpack_public_path__ + "static/img/partner-parkson.4ee0c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-parkson.png
// module id = E2Xa
// module chunks = 34